import { REDUCERS } from '../../constants/reducers';

const initialState = {
  currentTask: {
    description: '',
    endDate: '',
    recurringEndDate: '',
    recurringType: '',
    relationId: '',
    relationType: '',
    remindDate: '',
    startDate: '',
    title: '',
    userEmails: [],
    userIds: []
  },
  error: null,
  filteredTasks: [],
  loading: false,
  queryParams: {},
  selectedTasks: [],
  tasks: [],
  tasksForNextThreeDays: []
};

const task = (state = initialState, action) => {
  switch (action.type) {
    case REDUCERS.TASK.SET_TASK_STATE: {
      return Object.assign({}, state, {
        ...state,
        ...action.value
      });
    }
    case REDUCERS.TASK.SET_TASK_QUERY_PARAMS: {
      return Object.assign({}, state, {
        queryParams: { ...action.value }
      });
    }
    case REDUCERS.TASK.FETCH_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    case REDUCERS.TASK.FETCH_DATA_SUCCESS:
      return { ...state, loading: false, tasks: [...action.payload], filteredTasks: [...action.payload] };
    case REDUCERS.TASK.SET_TASKS_FOR_NEXT_THREE_DAYS:
      return { ...state, loading: false, tasksForNextThreeDays: [...action.payload] };
    case REDUCERS.TASK.FETCH_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case REDUCERS.TASK.SET_CURRENT_TASK: {
      return Object.assign({}, state, {
        currentTask: { ...state.currentTask, ...action.value }
      });
    }
    case REDUCERS.TASK.SET_TASKS:
      return { ...state, filteredTasks: [...action.value] };
    case REDUCERS.RESET:
      return initialState;
    default:
      return state;
  }
};

export { task };
